import { Home } from '@mui/icons-material';
import { Box, Breadcrumbs, Button, ButtonBase, Chip, Grid, IconButton, Link, Paper, Stack, SvgIcon, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ArrowBreadCrumbIcon, FolderIconBreadCrumb, ProductAffected } from '../Icons/CdsIcons';
import './CdsBreadCrumb.scss';
import TrainerService from '../../services/trainer/TrainerService';

export interface CdsBreadCrumbRoute {
  title: string;
  route: string;
  icon: any;
}

interface Props {
  routes: CdsBreadCrumbRoute[];
  folderBreadCrumb?: boolean;
  setCurrPage?: any;
  loadData?: any;
  setBreadCrumbRoute?: any;
  breadCrumbRoute?: any;
  workInstructionAppBar?: boolean;
  setWorkInstructionAppBar?: any;
}

const CdsBreadCrumb: React.FC<Props> = (props) => {

  useEffect(() => {
    if (props?.workInstructionAppBar) {
      const rootFolder = '';
      navigateFolders(rootFolder);
      props.setWorkInstructionAppBar(false);
    }
    
  }, [props.workInstructionAppBar]);

  const navigateFolders = (r) => {
    const folderId = r.folderId ? r.folderId : '';
    if (folderId) {
      TrainerService.getBreadCrumbPath(folderId, 'Folder').then((e) => {
        const home: any = { title: 'All Work Instruction' };
        const arr: any = [];
        arr.push(home);
        arr.push(...e.data.data);
        props.setBreadCrumbRoute(arr);
      });
    } else {
      props.setBreadCrumbRoute([]);
    }
    props.setCurrPage(1);
    props.loadData(folderId);
  };
  return (
    <Stack spacing={2}>
      <Breadcrumbs separator={<ArrowBreadCrumbIcon />} aria-label="breadcrumb" color="primary">
        {props.routes.map(
          (r, i) => (
            <Button onClick={() => navigateFolders(r)}>
              <Link underline="hover" color="inherit" key={i} sx={{ display: 'flex', alignItems: 'center' }}>
                {props.folderBreadCrumb ? (
                  <IconButton sx={{ marginRight: '4px' }}>
                    <FolderIconBreadCrumb />
                  </IconButton>
                ) : (
                  r.icon
                )}
                <Typography sx={{ fontSize: '12px' }}>{r.title}</Typography>
              </Link>
            </Button>
          ),
          // ),
        )}
      </Breadcrumbs>
    </Stack>
  );
};

export default CdsBreadCrumb;
